import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { assemblyServiceConfigSchema } from '../configurations/AssemblyServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderAssemblyDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.ASSEMBLY]: assemblyServiceConfigSchema,
    }),
});

export { servicesProviderAssemblyDataSchema };
//# sourceMappingURL=ServicesProviderAssemblyData.js.map
